/**
 * Created by tarun on 14/7/17.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/';

@Injectable()
export class UtilService {
  public editorConfig = {} as any;
  constructor(
    private http: HttpClient
  ) {
    this.editorConfig = {
      height: 500,
      plugins: ['table', 'lists', 'advlist', 'fullscreen', 'link'],
      toolbar: 'removeformat | bold | alignjustify | alignright | alignleft | aligncenter'
      + ' | numlist | bullist | outdent | indent | formatselect | link',
    };
  }
  getParam(param: string): Promise<string> {
    return Promise.resolve(param);
  }
  setBodyClass(className): void {
    document.body.className = className;
  }
  getByUrl(url): Observable<any> {
    return this.http.get(
      url,
      {}
    );
  }
  getAllResume(): Observable<any> {
    return this.http.get(
      `/my/resume`,
      {}
    );
  }
  getGooglePlaces(place: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?key=AIzaSyDvQ-yMRjBIJk7JMw7RPhQIOijr8pMz_j0&input=';
      url += place;
      xhr.open('GET', url, true);
      xhr.onload =  (e) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            console.log(xhr.responseText);
            resolve(xhr.responseText)
          } else {
            console.error(xhr.statusText);
            reject(xhr.statusText);
          }
        }
      };
      xhr.onerror = (e) => {
        console.error(xhr.statusText);
        reject(xhr.statusText);
      };
      xhr.send(null);
    });
  }
  attachFIle(files): Observable<any> {
    const fileList: FileList = files;
    const file: File = fileList[0];
    const formData: FormData = new FormData();
    formData.append('file', file);
    console.log(formData);
    return this.http.post(
      `/file`,
      formData,
      {}
    );
  }
  getRecommendedTitle(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/recommend/title`,
      {params}
    );
  }
  getExpText(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/data/exp_text`,
      {params}
    );
  }
  getProjText(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/data/proj_text`,
      {params}
    );
  }
}
